import { render, staticRenderFns } from "./ReceivingConfiguration.vue?vue&type=template&id=f9308aa4"
import script from "./ReceivingConfiguration.vue?vue&type=script&lang=js"
export * from "./ReceivingConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports